import React from 'react'
import CommonDepositForm from './CommonDepositForm'

const DirectDepositForm = (props) => {
  return <CommonDepositForm {...props} showBankAccountField={true} showDepositToCashOption={true} showTransferMessage={true} />
}

export default DirectDepositForm
